import ResponsiveImage from "@/components/image/ResponsiveImage"

export default {
    install(Vue) {
        Vue.component("ResponsiveImage", ResponsiveImage)
    },
}
